import { ActivitiesService } from './ActivitiesService'
import { DisciplinesService } from '@/src/server/modules/activities/DisciplinesService'
import { ActivityTypesService } from '@/src/server/modules/activities/ActivityTypesService'
import Vue from 'vue'
import axios from 'axios'

Vue.use({
  install (Vue) {
    Vue.prototype.$activitiesService = new ActivitiesService({ axios })
    Vue.prototype.$disciplinesService = new DisciplinesService({ axios })
    Vue.prototype.$activityTypesService = new ActivityTypesService({ axios })
  },
})



// WEBPACK FOOTER //
// ./src/server/modules/activities/ServiceProvider.js